import './scss/index.scss';

const eventFilters = [
    {
        root: '.events-issue-filter',
        button: '.events-issue-filter__button',
        popup: '.events-issue-filter__popup',
        facet: 'categories',
        count: '.events-issue-filter__count',
    },
    {
        root: '.events-audience-filter',
        button: '.events-audience-filter__button',
        popup: '.events-audience-filter__popup',
        facet: 'audience',
    },
    {
        root: '.events-year-filter',
        button: '.events-year-filter__button',
        popup: '.events-year-filter__popup',
        facet: 'event_year',
    },
];

const setFilterOpen = (filter, config, isOpen) => {
    const button = filter.querySelector(config.button);
    const popup = filter.querySelector(config.popup);

    if (!button || !popup) {
        return;
    }

    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    popup.hidden = !isOpen;
};

const closeFiltersExcept = (exceptFilter) => {
    eventFilters.forEach((config) => {
        document.querySelectorAll(config.root).forEach((filter) => {
            if (filter !== exceptFilter) {
                setFilterOpen(filter, config, false);
            }
        });
    });
};

document.addEventListener('click', (event) => {
    const match = eventFilters
        .map((config) => {
            const button = event.target.closest(config.button);

            if (!button) {
                return null;
            }

            return {
                config,
                button,
                filter: button.closest(config.root),
            };
        })
        .find(Boolean);

    if (match && match.filter) {
        const isOpen = match.button.getAttribute('aria-expanded') === 'true';

        closeFiltersExcept(match.filter);
        setFilterOpen(match.filter, match.config, !isOpen);

        return;
    }

    const clickedInsideFilter = eventFilters.some((config) => event.target.closest(config.root));

    if (!clickedInsideFilter) {
        closeFiltersExcept(null);
    }
});

document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
        return;
    }

    closeFiltersExcept(null);
});

const updateFilterCounts = () => {
    eventFilters.forEach((config) => {
        if (!config.count) {
            return;
        }

        const facetEl = document.querySelector(`.facetwp-facet-${config.facet}`);
        const countEl = document.querySelector(config.count);

        if (!facetEl || !countEl) {
            return;
        }

        const checked = facetEl.querySelectorAll('.facetwp-checkbox.checked').length;
        countEl.textContent = checked > 0 ? ` (${checked})` : '';
    });
};

const repopulateEventFacets = () => {
    const facets = window.FWP && window.FWP.response && window.FWP.response.facets
        ? window.FWP.response.facets
        : null;

    if (!facets) {
        return;
    }

    eventFilters.forEach((config) => {
        const html = facets[config.facet];

        if (typeof html !== 'string' || html === '') {
            return;
        }

        document.querySelectorAll(`.facetwp-facet-${config.facet}`).forEach((facet) => {
            facet.innerHTML = html;
        });
    });

    updateFilterCounts();
};

document.addEventListener('containerReplaceAfter.tribeEvents', repopulateEventFacets);

document.addEventListener('click', (event) => {
    if (event.target.closest('.facetwp-checkbox')) {
        setTimeout(updateFilterCounts, 0);
    }
});

updateFilterCounts();
